define(["underscore","backbone"],
    function(_, Backbone) {
        return Backbone.Model.extend({
            idAttribute: 'spread_swap_quotes',
            urlRoot: "/rest_quotes_feeder/spread_swap_quotes/",
            url: "/rest_quotes_feeder/spread_swap_quotes/"
        });
    });
